// Export the refactored migration system

export { DatabaseMigrationAdapter } from './DatabaseMigrationAdapter';
export { MigrationClient } from './MigrationClient';

// Export interfaces
export type { 
  MigrationResponse, 
  MigrationOperation, 
  EntityType, 
  BatchResult,
  IDataTransformer,
  IMigrationClient,
  IEntityHandler
} from './interfaces';

// Export handlers for direct use if needed
export { PatientHandler } from './handlers/PatientHandler';
export { RecordingHandler } from './handlers/RecordingHandler';
export { UserHandler } from './handlers/UserHandler';
export { TemplateHandler } from './handlers/TemplateHandler';

// Export transformers for direct use if needed
export { createTransformer } from './transformers';

// Create singleton instance for backward compatibility
import { DatabaseMigrationAdapter } from './DatabaseMigrationAdapter';
export const databaseMigrationAdapter = DatabaseMigrationAdapter.getInstance(); 